// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"91447518","99":"cda59a37","128":"30aefcf2","178":"16766dd2","289":"6903c930","329":"bcd3d269","336":"1aab650a","577":"4b47278f","599":"3cd07291","790":"4aaf5d21","886":"e5d919fd","974":"f23cc0a8"}[chunkId] + ".chunk.js";
};